"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FarmListController_1 = __importDefault(require("../modules/controllers/FarmListController"));
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const WKT_1 = __importDefault(require("ol/format/WKT"));
let FarmTable = class FarmTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.CONTROLLER = FarmListController_1.default.getInstance();
        this.rowFarmSelected = null;
        this.fieldsChecked = [];
        this.isCheckedGlobal = false;
        this.fieldCenterId = -1;
        /*     async pushFn(field: GisField) {
                if (this.isCheckedGlobal) {
                    this.isCheckedGlobal = false
                }
        
                if (this.fieldExists(field.id)) {
                    removeFeatureByName(findLayerById('zone-layer', this.map.map), `${field.id}-${field.fieldName}`)
        
                    this.STEP_MODEL.removeSelectedField(field.id);
        
                    if (this.STEP_MODEL.data.selectedFields.length < 1) {
                        this.resetGisAreasChecked();
                    }
                } else {
                    this.STEP_MODEL.addSelectedFields(field);
                }
        
            } */
    }
    updateStyleRows() {
        this.rowFarmSelected = null;
    }
    drawFarmInMap(farm) {
        this.rowFarmSelected = farm;
        this.$emit('drawFarmInMap', farm);
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
        if (!this.isCheckedGlobal) {
            this.fieldsChecked = [];
        }
        else {
            this.fieldsChecked = this.fields.map((g) => g.id);
        }
        this.$emit('updateFieldsForQuote', this.fieldsChecked);
    }
    selectField(field) {
        /*         this.pushFn(field);
                this.$emit('drawNewFieldInMap') */
        if (this.isFieldChecked(field.id)) {
            this.fieldsChecked = this.fieldsChecked.filter((g) => g !== field.id);
        }
        else {
            this.fieldsChecked.push(field.id);
        }
        this.$emit('updateFieldsForQuote', this.fieldsChecked);
    }
    isFieldChecked(fieldId) {
        if (this.fieldsChecked.includes(fieldId)) {
            return true;
        }
        return false;
    }
    async centerField(id) {
        const field = this.fields.find((f) => f.id === id);
        const feature = new WKT_1.default().readFeature(field.geodata, this.projections);
        const geometry = feature.getGeometry();
        if (this.fieldCenterId === id) {
            this.fieldCenterId = -1;
        }
        else {
            this.fieldCenterId = id;
        }
        await this.centerZone(geometry.getExtent(), [100, 100, 100, 100]);
    }
    async centerZone(extent, padding) {
        await (0, CenterUtility_1.center)(this.map.map, extent, 700, padding);
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmTable.prototype, "map", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmTable.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmTable.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('farms')
], FarmTable.prototype, "updateStyleRows", null);
FarmTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, CodeSnippet: bmk_ui_framework_1.CodeSnippet, CheckBox: bmk_ui_framework_1.CheckBox }
    })
], FarmTable);
exports.default = FarmTable;
